import { Phone, MessageCircle } from 'lucide-react'

export default function OrderPage() {
  return (
    <div className="min-h-screen bg-umber flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <img src="/logo.jpg" alt="Desres Kitchen" className="w-20 h-20 object-contain mx-auto mb-6" />
        <h1 className="font-display text-cream tracking-wide mb-2" style={{ fontSize: 'clamp(28px, 5vw, 44px)' }}>
          Desres Kitchen &amp; Confectionery
        </h1>
        <div className="w-16 h-0.5 bg-terracotta mx-auto mb-8" />
        <p className="text-ink-mid text-base leading-relaxed mb-8">
          We're updating our online ordering.<br />
          Please contact us directly to place an order.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+27767072"
            className="inline-flex items-center justify-center gap-2 bg-cream text-umber font-body text-sm font-bold tracking-wide uppercase px-6 py-3 border border-border-dark hover:border-terracotta transition-colors"
          >
            <Phone size={16} /> Call Us
          </a>
          <a
            href="https://wa.me/27767072"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-terracotta text-white font-body text-sm font-bold tracking-wide uppercase px-6 py-3 hover:bg-terracotta-glow transition-colors"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
        </div>
        <p className="text-muted text-xs mt-10">We'll be back online soon.</p>
      </div>
    </div>
  )
}
